export default __webpack_public_path__ + "static/media/Apple logo.3a3e608e.png";